import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ColorService from '@/services/color.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftItemColors',
  props: {
    colors: { default: () => [] }
  },
  emits: ["colorClicked"],
  setup(__props: any, { emit }: { emit: ({(e: 'colorClicked', value: IColorBaubles) : void}), expose: any, slots: any, attrs: any }) {

const props = __props as { colors: IColorBaubles[] }



const baubleStyle = computed<any>(() => {
    return (color: IColorBaubles) => {
        return color.colorImage
            ? { backgroundImage: `url('${color.colorImage}')`, backgroundSize: 'contain' }
            : { backgroundColor: color.hex };
    };
});



function onColorClicked(color: IColorBaubles): void {
    emit('colorClicked', color);
}

function isColorLight(color: string): boolean {
    return ColorService.isColorLight(color);
}

return { __sfc: true,props, baubleStyle, emit, onColorClicked, isColorLight }
}

})